import React, { useState, useEffect } from "react";
import ShareTable from "../../../shares/tables/ShareTable";
import {
  DeleteOutline,
  EditOutlined,
  FileDownloadOutlined,
  GroupsOutlined,
  AddRounded,
} from "@mui/icons-material";
import { Modal, CircularProgress } from "@mui/material";
import AddGroups from "./modals/AddGroups";
import useFetch from "../../../../hooks/useFetch";
import useDownload from "../../../../hooks/useDownload";
import { endpoints } from "../../../../api/endpoints";
import Search from "../../../shares/search/Search";
import { useSearchParams } from "react-router-dom";
import {
  PageHeader,
  TableAction,
} from "../../../shares/dashboard/DashboardWidgets";

const Groups = () => {
  const [newModal, setNewModal] = useState(false);
  const [edit, setEdit] = useState(null);
  const [groups, setGroups] = useState();
  const [id, setId] = useState(null);
  const { download, loading: downloading } = useDownload();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleClose = () => {
    setNewModal(false);
    setEdit(null);
  };

  const handleEdit = (id) => {
    setNewModal(true);
    setEdit(id);
  };

  const getGroup = useFetch({
    method: "GET",
    url: endpoints.management.groups,
    params: {
      page: searchParams.get("page") ?? 1,
      search: searchParams.get("search") ?? "",
    },
    safeRead: true,
    noHeader: false,
    trigger: true,
    setter: setGroups,
  });

  const deleteGroup = useFetch({
    method: "DELETE",
    url: `management/groups/${id}/`,
    noHeader: false,
    trigger: false,
    caller: getGroup,
    argFunc: () => {
      if (groups?.results.length === 1) {
        setSearchParams((prev) => {
          const next = new URLSearchParams(prev);
          next.set("page", Math.max(1, Number(searchParams.get("page") || 1) - 1));
          return next;
        });
      }
      setId(null);
    },
  });

  useEffect(() => {
    id && deleteGroup.reFetch();
  }, [id]);

  const columns = [
    { id: "id", label: "شناسه" },
    { id: "name", label: "نام" },
    { id: "group_time", label: "زمان شروع" },
    { id: "group_grade", label: "مقطع" },
    {
      id: "exam",
      label: "اکسل امتحانات",
      render: (row) => (
        <TableAction
          icon={FileDownloadOutlined}
          onClick={() => download(endpoints.management.exportExams(row.id), "exam-scores-" + row.id + ".xlsx")}
          disabled={downloading}
          label="دریافت اکسل امتحانات"
          tone="primary"
        />
      ),
    },
    {
      id: "homework",
      label: "اکسل تکالیف",
      render: (row) => (
        <TableAction
          icon={FileDownloadOutlined}
          onClick={() => download(endpoints.management.exportAssignments(row.id), "assignment-scores-" + row.id + ".xlsx")}
          disabled={downloading}
          label="دریافت اکسل تکالیف"
          tone="primary"
        />
      ),
    },
    {
      id: "edit",
      label: "ویرایش",
      render: (row) => (
        <TableAction
          icon={EditOutlined}
          onClick={() => handleEdit(row.id)}
          label="ویرایش گروه"
        />
      ),
    },
    {
      id: "delete",
      label: "حذف",
      render: (row) =>
        deleteGroup.loading && id === row.id ? (
          <CircularProgress size="2rem" color="inherit" className="text-danger" />
        ) : (
          <TableAction
            icon={DeleteOutline}
            onClick={() => setId(row.id)}
            label="حذف گروه"
            tone="danger"
          />
        ),
    },
  ];

  return (
    <div className="flex flex-col gap-xl pb-4xl">
      <PageHeader
        title="گروه‌ها"
        description="مدیریت گروه‌های کلاسی، زمان‌بندی و خروجی نمرات"
        icon={GroupsOutlined}
        actionLabel="افزودن گروه"
        actionIcon={AddRounded}
        onAction={() => setNewModal(true)}
      />

      <div className="flex flex-col gap-lg">
        <Search getFiltered={getGroup} />

        <ShareTable
          data={groups?.results ?? []}
          columns={columns}
          getPage={getGroup}
          totalCount={groups?.count}
          page={Number(searchParams.get("page")) || 1}
          setPage={setSearchParams}
        />
      </div>

      <Modal
        open={newModal}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <AddGroups close={handleClose} get={getGroup} edit={edit} />
      </Modal>
    </div>
  );
};

export default Groups;
